import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import api from '../api';

const card: React.CSSProperties = {
  border: '1px solid #ccc',
  padding: '30px',
  borderRadius: '8px',
};

const field: React.CSSProperties = {
  width: '100%',
  padding: '10px',
  fontSize: '16px',
  border: '1px solid #ccc',
  borderRadius: '4px',
  boxSizing: 'border-box',
};

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as any)?.from?.pathname || '/app';

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { data } = await api.post('/api/auth/login', { email, password });
      login(data.token, data.user);
      navigate(data.user.role === 'admin' ? '/admin' : from, { replace: true });
    } catch (err) {
      setError(
        axios.isAxiosError(err)
          ? err.response?.data?.error || 'Invalid email or password.'
          : 'Login failed. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '40px 20px', maxWidth: '400px', margin: '80px auto', fontFamily: 'Arial' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '6px' }}>Financial Roleplay Training</h1>
      <p style={{ textAlign: 'center', color: '#666', marginBottom: '28px' }}>Sign in to your account</p>

      <div style={card}>
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ background: '#ffebee', color: '#c62828', padding: '10px 14px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '15px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required autoFocus style={field} placeholder="you@example.com"
            />
          </div>

          <div style={{ marginBottom: '22px' }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Password</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required style={field} placeholder="••••••••"
            />
          </div>

          <button
            type="submit" disabled={loading}
            style={{ width: '100%', padding: '12px', fontSize: '16px', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
          >
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#555' }}>
          <Link to="/reset-password" style={{ color: '#2196F3', textDecoration: 'none' }}>Forgot password?</Link>
          <span style={{ margin: '0 10px', color: '#ddd' }}>|</span>
          <Link to="/register" style={{ color: '#2196F3', textDecoration: 'none' }}>Create account</Link>
        </div>
      </div>
    </div>
  );
}
